import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  onExpire?: () => void;
}
// Helper function to calculate 4-hour deadline from first visit
const getFourHourDeadline = () => {
  const now = new Date();
  const fourHoursLater = new Date(now.getTime() + 4 * 60 * 60 * 1000); // 4 hours in milliseconds
  return fourHoursLater.getTime();
};
// Helper function to calculate time left
const calculateTimeLeft = (expiryTimestamp: number) => {
  const now = new Date().getTime();
  const distance = expiryTimestamp - now;
  if (distance <= 0) {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  const hours = Math.floor(distance / (1000 * 60 * 60));
  const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(distance % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
};
export function CountdownTimer({
  onExpire = () => {}
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 0,
    seconds: 0
  });
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    // Initialize or get existing expiry time
    let expiryTime = localStorage.getItem('masterclassTimerExpiry');
    if (!expiryTime) {
      const deadline = getFourHourDeadline();
      localStorage.setItem('masterclassTimerExpiry', deadline.toString());
      expiryTime = deadline.toString();
    }
    // Set initial time immediately
    setTimeLeft(calculateTimeLeft(parseInt(expiryTime)));
    const updateTimer = () => {
      const expiryTimestamp = parseInt(expiryTime!);
      const newTimeLeft = calculateTimeLeft(expiryTimestamp);
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        onExpire();
      }
    };
    // Update every second
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [onExpire]);
  if (!isClient) {
    return <div className="text-center" data-id="element-192">
        <p className="text-xl text-gray-300 mb-2 font-semibold" data-id="element-193">
          Oferta Especial Expira En:
        </p>
        <p className="text-lg text-[#06b6d4] mb-4 font-bold" data-id="element-194">
          Se Cierra el Carrito y los Bonos
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-195">
          <TimeUnit value={4} label="Horas" data-id="element-196" />
          <TimeUnit value={0} label="Minutos" data-id="element-197" />
          <TimeUnit value={0} label="Segundos" data-id="element-198" />
        </div>
      </div>;
  }
  return <div className="text-center" data-id="element-199">
      <p className="text-xl text-gray-300 mb-2 font-semibold" data-id="element-200">
        Oferta Especial Expira En:
      </p>
      <p className="text-lg text-[#06b6d4] mb-4 font-bold" data-id="element-201">
        Se Cierra el Carrito y los Bonos
      </p>
      <div className="flex items-center justify-center gap-4" data-id="element-202">
        <TimeUnit value={timeLeft.hours} label="Horas" data-id="element-203" />
        <TimeUnit value={timeLeft.minutes} label="Minutos" data-id="element-204" />
        <TimeUnit value={timeLeft.seconds} label="Segundos" data-id="element-205" />
      </div>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-206">
      <div className="bg-gradient-to-br from-[#06b6d4] to-[#0891b2] rounded-lg w-20 h-20 flex items-center justify-center text-3xl font-bold shadow-lg" data-id="element-207">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-sm text-gray-400 mt-2 font-medium" data-id="element-208">{label}</span>
    </div>;
}